import { useAppSelector } from 'app/store';
import { useWebSocketConnectionLink } from 'app/utils/hooks/webSockets/useWebSocketConnectionLink';
import useReactWebSocket, { ReadyState } from 'react-use-websocket';
import { useEffect, useMemo, useState } from 'react';
import useInterval from 'use-interval';
import { getActivityPingInterval } from 'app/store/WebSockets/selectors';

export const useActivityPing = () => {
  const [
    visibilityState,
    setVisibilityState,
  ] = useState<DocumentVisibilityState>(document.visibilityState);
  const pingInterval = useAppSelector(getActivityPingInterval);
  const [pinged, setPinged] = useState(false);
  const { connectionUrl } = useWebSocketConnectionLink();

  const { readyState, sendJsonMessage } = useReactWebSocket(connectionUrl, {
    share: true,
  });

  const ping = useMemo(
    () => () => {
      sendJsonMessage({ type: document.hidden ? 'Inactive' : 'ActivityPing' });
    },
    [sendJsonMessage]
  );

  const stopPolling =
    visibilityState === 'hidden' ||
    readyState !== ReadyState.OPEN ||
    !pingInterval;

  useInterval(ping, stopPolling ? null : pingInterval * 1000, true);

  useEffect(() => {
    if (!stopPolling && !pinged) {
      setPinged(true);
      ping();
    }
  }, [stopPolling, pinged, ping]);

  useEffect(() => {
    const handler = () => {
      setVisibilityState(document.visibilityState);
      ping();
    };
    document.addEventListener('visibilitychange', handler);

    return () => {
      document.removeEventListener('visibilitychange', handler);
    };
  }, [ping]);
};
